<template>
  <div>
    <div>
      <Button type="primary" @click.native="newSeal"
              v-show="!order.id || (order.id && order.orderState<1)">新增印章
      </Button>
      <span class="p-l-20">共 {{order.seals.length}} 个印章，合计 {{totalPrice|currency}} </span>
    </div>
    <div class="m-t-15">
      <Row :gutter="10">
        <Col :span="12" class="m-t-10" v-for="(item,index) in order.seals" :key="item.id">
          <Card dis-hover>
            <div slot="title" class="tb-row-scatter h-24-px">
              <div v-dict:DictSocietySealsite_sealType="item.sealType" class="tb-column-center"></div>
              <div class="tb-row-center">
<!--                <Icon type="ios-compose-outline" size="20" class="c-h p-r-24"-->
<!--                      @click.native="nowMaterial=item;selectSealEditFun(item)"></Icon>-->
                <Icon type="ios-trash-outline" size="20" class="c-h"
                      @click.native="removeSeal(item,index)"
                      v-show="!order.id || (order.id && order.orderState<1)"></Icon>
              </div>
            </div>
            <Row class="p-t-10">
              <Col span="8" class="text-c">
                <ImageView :src="item.matPhotoOss"></ImageView>
              </Col>
              <Col span="16">
                <p class="p-5">{{item.name}}</p>
                <p class="p-5 c-gray ti_line-height-18px h-36-px">{{item.matName}}</p>
                <p class="p-5 text-r">{{item.matPrice|currency}}</p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>

    <Modal v-model="sealModal.show" :title="sealModal.seal.id?'编辑印章':'添加印章'"
           @on-ok="saveSeal" :width="600">
      <Form :model="sealModal.seal" :label-width="100" ref="sealForm" :rules="sealModal.rules">

        <FormItem label="印章类型：" prop="sealType">
          <SelectPro option-data="DictSocietySealsite_sealType" :valueSelected="sealModal.seal.sealType"
                     placeholder="请选择印章类型" @on-change="onChangeSealType"></SelectPro>
<!--          <Select v-model="sealModal.seal.sealType" placeholder="请选择" :disabled="!!sealModal.seal.id"-->
<!--                  :label-in-value="true" @on-change="sealTypeChangeFun">-->
<!--            <Option v-for="(value,key) in sealModal.sealType" :key="key" :value="key">{{value}}</Option>-->
<!--          </Select>-->
        </FormItem>

        <FormItem label="印章名称：" prop="name">
          <Input v-model="sealModal.seal.name" placeholder="请输入印章名称"></Input>
        </FormItem>

        <FormItem label="印章材质：" prop="matId">
          <div v-if="!sealModal.seal.id">
            <div v-show="!sealModal.seal.sealType">请先选择印章类型</div>

            <div v-show="sealModal.seal.sealType && sealModal.materials.length===0">本店暂时无法制作该类型印章</div>

            <Card v-show="sealModal.materials.length > 0" v-for="(item, index) in sealModal.materials" :key="index" @click.native="onChangeMaterial(item.id)">
              <div class="p-l-16 p-r-16 p-t-16" >
                <div class="p-12 tb-row b-b-1" :class="{'boxShadow': sealModal.seal.matId === item.id}">
                  <div class="ti-g-1">
                    <img :src="item.matPhotoOss|img_oss" class="w-100">
                  </div>
                  <div class="ti-g-2 tb-column p-l-12">
                    <div class="tb-row-scatter">
                      <div style="width:150px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">
                        {{item.matName}}
                      </div>
                    </div>
                    <div>{{item.matPrice|currency}}</div>
                    <div class="f-12 m-t-10 c-gray">{{item.matIntro}}</div>
                  </div>
                  <div style="margin-top:-12px;margin-right:-12px">
                    <img class="w-36-px" src="img/yixuan.png" v-show="sealModal.seal.matId === item.id">
                  </div>
                </div>
              </div>
            </Card>
          </div>
<!--          <div v-else class="tb-row">-->
<!--            <div class="ti-g-1">-->
<!--              <img :src="sealModal.seal.matPhotoOss|img_oss('tubo_11_tiny')" class="w-100">-->
<!--            </div>-->
<!--            <div class="ti-g-2 p-l-12">-->
<!--              <div class="ti_line-height-20px" style="font-weight:600">{{sealModal.seal.matName}}-->
<!--              </div>-->
<!--              <div class="m-t-8 c-red">{{sealModal.seal.matPrice|currency}}</div>-->
<!--              <div class="ti_line-height-18px m-t-8">-->
<!--                {{sealModal.seal.matIntro}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </FormItem>
        <!-- <div v-show="!sealModal.seal.id">
          <i-select v-model="sealModal.seal.matId" placeholder="请选择" @on-change="materialChangeFun">
            <i-option v-for="item in material" :key="item.id" :value="item.id">{{item.matName}}</i-option>
          </i-select>
        </div>
        <div v-show="sealModal.seal.id">
          <span>{{sealModal.seal.matName}}</span>
        </div> -->

        <!-- <FormItem label="详细介绍：">
          <span>{{sealModal.seal.matIntro || sealModal.material.matIntro}}</span>
        </FormItem>

        <FormItem label="章材的图片 ：">
          <ImageView :src="sealModal.seal.matPhotoOss || sealModal.material.matPhotoOss"></ImageView>
        </FormItem>

        <FormItem label="印章价格：">
          <span>{{(sealModal.seal.matPrice || sealModal.material.matPrice)|currency}}</span>
        </FormItem> -->
      </Form>
    </Modal>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {dict, http, api} from '@/libs'

  export default {
    name: 'OrderSelectSeal',
    data() {
      return {
        sealModal: {
          show: false,
          seal: {name: '', sealType: null, matId: null},
          materials: [],
          // sealType: {},
          // material: {},
          rules: {
            name: [{required: true, trigger: 'blur', message: '请输入印章名称'}],
            sealType: [{required: true, trigger: 'change', message: '请输选择印章类型'}],
            matId: [{required: true, trigger: 'change', message: '请输选择印章材质', type: 'number'}]
          }
        },
        materials: null // 刻章店全部的材料列表
      }
    },
    computed: {
      ...mapState({
        order: state => state.order.currentOrder,
        companySelected: state => state.order.companySelected
      }),
      totalPrice() {
        return this.order.seals.reduce((first, second) => first + second.matPrice, 0)
      },
    },
    updated() {
    },
    methods: {
      // 保存印章
      saveSeal() {
        this.$store.dispatch('order/postOrderSeal', {
          orderId: this.order.id,
          sealJson: this.sealModal.seal
        }).then(() => {
          this.$store.dispatch('order/getOrderById', {id: this.order.id})
        })
      },
      // 删除印章
      removeSeal(item, index) {
        console.log("removeSeal", item, index)
        let that = this
        this.$Modal.confirm({
          title: '删除印章',
          content: item.name,
          onOk() {
            that.$store.dispatch('order/deleteOrderSeal', {id: item.id}).then(() => {
              that.order.seals.splice(index, 1)
              that.$forceUpdate()
            })
          }
        })
      },

      onChangeMaterial(matId) {
        console.log("onChangeMaterial", matId)
        this.sealModal.seal.matId = matId
      },

      // 新增印章对话框, 选择印章类型
      onChangeSealType(item) {
        console.log("onChangeSealType", item)

        if (!item.value)
          return

        this.sealModal.seal.sealType = item.value

        if (item.value==='99' || item.value==='01') { // 法定名称章和其他印章
          this.sealModal.seal.name = this.order.name
        } else if (item.value==='05') { // 法定代表人名章
          this.sealModal.seal.name = this.order.crpName + '印'
        } else { // 除上述之外都加上印章类型名
          this.sealModal.seal.name = this.order.name + item.label
        }

        this.sealModal.seal.name = this.sealModal.seal.name.replace(/\ +/g,"");
        this.sealModal.seal.name = this.sealModal.seal.name.replace(/[\r\n]/g,"");

        // 过滤印章材料
        this.sealModal.materials = this.materials.filter(node => node.sealType === item.value)

        // 选择第一个章材（如果有）
        if (this.sealModal.materials.length > 0)
          this.sealModal.seal.matId = this.sealModal.materials[0].id
      },

      // 新增印章
      newSeal() {
        Object.assign(this.sealModal, {
          show: true,
          seal: {
            orderId: this.order.id,
            name: '',
            matId: null,
            sealType: null,
          },
          materials: []
        })

        this.onChangeSealType({value: '01'})

        // this.materialActive = null
        // this.selectedMaterialIndex = null
        // this.$refs.sealForm.resetFields()
        // Object.assign(this.sealModal, {
        //   show: true,
        //   loading: true,
        //   seal: {orderId: this.order.id, name: ''},
        //   material: {}
        // })
        // this.material = []
        // this.sealModal.seal.sealType = '01'
        // this.sealTypeChangeFun({value: '01'})
      },

      // // 编辑印章
      // selectSealEditFun(item) {
      //   this.$refs.sealForm.resetFields()
      //   const material = this.materialData.find(node => node.id == item.matId) || {}
      //   Object.assign(this.sealModal, {
      //     show: true,
      //     loading: true,
      //     material: JSON.parse(JSON.stringify(material)),
      //     seal: JSON.parse(JSON.stringify(item))
      //   })
      // },

      // //选择印章材料
      // materialChangeFun(val) {
      //   if (val) {
      //     this.sealModal.material = this.materialData.find(item => item.id == val)
      //   }
      // },
    },
    created() {
 //     dict.dict('DictSocietySealsite_sealType').then(payload => this.sealModal.sealType = payload.content)

      // 查询刻章店全部材料
      http.get(api.gzwCusOrder.queryMaterial, {params: {companyId: this.companySelected.id}}).then(payload => {
        this.materials = payload
      })
    }
  }
</script>